import { useEffect, useMemo } from 'react';
import { AutocompleteElement, useFormContext, useWatch } from 'react-hook-form-mui';
import { useStateProvinces } from '../../../../sic-lib/api/hooks/useResources';

type Props = {
    name: string;
    label: string;
    required?: boolean;
};

//this thing is dependant on another field in the form with a name of 'country'
export function StatesProvinceAutocompleteElement({ ...props }: Props) {
    const selectedCountry = useWatch({ name: 'country' }) as string | undefined;
    const { setValue } = useFormContext();
    const { data: apiData, isFetching } = useStateProvinces(selectedCountry);

    //changing countries resets the stateProvince field
    useEffect(() => {
        if (selectedCountry) {
            setValue(props.name, '');
        }
    }, [props.name, selectedCountry, setValue]);

    const stateProvinces = useMemo(() => {
        return (
            apiData?.map(stateProv => {
                return {
                    id: stateProv.provCode,
                    label: stateProv.provName,
                };
            }) || []
        );
    }, [apiData]);

    return (
        <AutocompleteElement
            {...props}
            loading={isFetching}
            options={stateProvinces}
            matchId={true}
            autocompleteProps={{
                disabled: !selectedCountry,
                renderOption: (props, option) => (
                    <li {...props} key={option.id}>
                        {option.label}
                    </li>
                ),
            }}
        />
    );
}
